import React from 'react';
import cn from 'classnames';

import { BaseButton } from '../Buttons';
import { renderNodeOrComponent } from '../utils';
import { LinkButtonProps } from './types';
import { getLinkButtonClasses, getLinkButtonIconClasses } from './utils';

const defaultClasses = { endIcon: '!m-0', startIcon: '!m-0' };

const LinkButton = React.forwardRef<HTMLButtonElement, LinkButtonProps>((props, ref) => {
  if ('Icon' in props) {
    const { className, color = 'internal', Icon, size = 'medium', ...rest } = props;
    const classes = getLinkButtonIconClasses({ color, size });

    return (
      <BaseButton ref={ref} className={cn(classes.root, className)} {...rest}>
        <Icon className={classes.icon} />
      </BaseButton>
    );
  }

  const {
    classes: classesProp = defaultClasses,
    className,
    color = 'internal',
    endIcon,
    EndIcon,
    fontWeight = 'heading',
    size = 'small',
    startIcon,
    StartIcon,
    typography,
    ...rest
  } = props;

  const classes = getLinkButtonClasses({ color, fontWeight, size, typography });

  return (
    <BaseButton
      ref={ref}
      className={cn(classes.root, className)}
      classes={classesProp}
      endIcon={renderNodeOrComponent({ Component: EndIcon, node: endIcon })}
      startIcon={renderNodeOrComponent({ Component: StartIcon, node: startIcon })}
      {...rest}
    />
  );
});

export default LinkButton;
